// extracted by mini-css-extract-plugin
export default {"files":"files___Dfb2dVN","title":"title___Dfb2dVN","info":"info___Dfb2dVN","main":"main___Dfb2dVN","action":"action___Dfb2dVN","btn":"btn___Dfb2dVN"};